<template lang="html">
  <Span ref="mySpan" v-if="isShow">
    <div class="loading-page">
      <div class="ant-spin ant-spin-spinning">
        <span class="ant-spin-dot ant-spin-dot-spin">
          <i class="ant-spin-dot-item"></i>
          <i class="ant-spin-dot-item"></i>
          <i class="ant-spin-dot-item"></i>
          <i class="ant-spin-dot-item"></i>
          </span>
        </div>
    </div>
  </Span>
</template>
<script>
import "loaders.css";
export default {
  props: ["isShow"],
  //使用方式
  watch: {
    //局部laoding
    isShow(newVal) {
      if (!newVal) {
        this.$refs.mySpan.parentNode.classList.remove("maskContainer");
      } else {
        this.$nextTick(() => {
          this.$refs.mySpan.parentNode.classList.add("maskContainer");
        });
      }
    }
  },
  mounted() {
    this.$refs.mySpan &&
      this.$refs.mySpan.parentNode.classList.add("maskContainer");
    // console.log(this.$refs.mySpan.$el.parentNode);
  }
};
</script>

<style lang="scss" scoped>
@keyframes antSpinMove {
  100% {
    opacity: 1;
  }
}
@keyframes antRotate {
  100% {
    transform: rotate(405deg);
  }
}
.loading-page {
  .ant-spin-spinning {
    position: static;
    display: inline-block;
    opacity: 1;
  }
  .ant-spin {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    font-feature-settings: "tnum";
    position: absolute;
    // display: none;
    color: #1890ff;
    text-align: center;
    vertical-align: middle;
    // opacity: 0;
    transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    position: absolute;
    z-index: 101;
    .ant-spin-dot-spin {
      transform: rotate(45deg);
      animation: antRotate 1.2s linear infinite;
    }
    .ant-spin-dot {
      position: relative;
      display: inline-block;
      font-size: 20px;
      width: 1em;
      height: 1em;
      top: 45%;
      .ant-spin-dot-item {
        position: absolute;
        display: block;
        width: 9px;
        height: 9px;
        background-color: #1890ff;
        border-radius: 100%;
        transform: scale(0.75);
        transform-origin: 50% 50%;
        opacity: 0.3;
        animation: antSpinMove 1s linear infinite alternate;
      }
      .ant-spin-dot-item:first-child {
        top: 0;
        left: 0;
      }
      .ant-spin-dot-item:nth-child(2) {
        top: 0;
        right: 0;
        animation-delay: 0.4s;
      }
      .ant-spin-dot-item:nth-child(3) {
        right: 0;
        bottom: 0;
        animation-delay: 0.8s;
      }
      .ant-spin-dot-item:nth-child(4) {
        bottom: 0;
        left: 0;
        animation-delay: 1.2s;
      }
    }
  }
}
</style>
